// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { List } from './list';
import { escapeAttribute } from './common';

/**
 * @class Jsw.GroupsList
 * @extends Jsw.List
 */
export const GroupsList = Class.create(List, {
    _groupBy: false,
    _groupsConfig: [],

    _getGroupRowClass(group) {
        return '';
    },

    _initConfiguration($super, config) {
        $super(config);
        this._groupBy = this._getConfigParam('groupBy', false);
        this._groupsConfig = this._getConfigParam('groupsConfig', false);
        this._getGroupRowClass = this._getConfigParam('getGroupRowClass', this._getGroupRowClass);
    },

    _getListDataHtml(listData, indexOffset) {
        if ('undefined' === typeof listData) {
            listData = this._data;
        }

        if (!listData) {
            return;
        }

        indexOffset = indexOffset || 0;

        if (this._groupBy) {
            listData = listData.sort(function (a, b) {
                if (a[this._groupBy] > b[this._groupBy]) {
                    return 1;
                }
                if (a[this._groupBy] < b[this._groupBy]) {
                    return -1;
                }
                return 0;
            }.bind(this));

            const groupedData = {};
            listData.forEach(function (item) {
                if (!groupedData[item[this._groupBy]]) {
                    groupedData[item[this._groupBy]] = {
                        id: item[this._groupBy],
                        items: [],
                    };
                }
                groupedData[item[this._groupBy]].items.push(item);
            }.bind(this));

            return Object.keys(groupedData).map(function (groupId, groupIndex) {
                const group = groupedData[groupId];
                return this._getGroupDataRowHtml(group, groupIndex, indexOffset);
            }.bind(this)).join('');
        }

        return listData.map(function (item, index) {
            return this._getRowHtml(item, index, indexOffset);
        }.bind(this)).join('');
    },

    _getGroupDataRowHtml(group, groupIndex, indexOffset) {
        let html = '';
        const groupRowClass = this._getGroupRowClass(group);

        const oddEvenRowClass = (groupIndex + indexOffset) % 2 ? 'even' : 'odd';
        const groupRowId = group.id ? escapeAttribute(group.id) : '';
        html += `<tr class="${groupRowClass} ${oddEvenRowClass}" data-row-id="${groupRowId}"><td colspan=`;
        html += `${this._columns.length}'>`;
        html += `<b>${this._getGroupName(group)}</b>`;

        html += '</td></tr>';

        html += group.items.map(function (item, index) {
            return this._getRowHtml(item, index, indexOffset);
        }.bind(this)).join('');
        return html;
    },

    _getGroupName(group) {
        return this._groupsConfig[group.id] ? this._groupsConfig[group.id] : group.id;
    },
});



// WEBPACK FOOTER //
// ./jsw/groups-list.js